// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.miniChartsWidget {
  overflow-x: auto;
  overflow-y: hidden;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  padding: 16px 0;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.mini-charts-list {
  display: flex;
  flex-direction: row;
  gap: 24px;
  padding: 0 16px;
  margin: 0;
  list-style: none;
}

.mini-chart-item {
  flex: 0 0 123px;
  max-width: 123px;
  display: flex;
  flex-direction: column;
}

.ticker-block {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin-bottom: 4px;
}

.ticker-block .flag-icon svg,
.ticker-block .flag-icon img {
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: block;
}

.ticker-block .ticker {
  font-size: 16px;
  color: var(--text-ticker);
  font-weight: 700;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.company-name {
  width: 100%;
  font-weight: 400;
  font-size: 12px;
  color: var(--text-instrument);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 8px;
}

.last-price {
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  color: var(--text-primary);
  margin-bottom: 0px;
}

.chart-container {
  width: 100%;
  height: 50px;
  padding-top: 8px;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.chart-container img,
.chart-container svg {
  width: 100%;
  height: 100%;
  display: block;
  margin-right: 22px;
}

.chart-empty-line {
  width: 100%;
  height: 20px;
  border-bottom: 1px dashed var(--border-tertiary);
}

.pct-chg {
  width: auto;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
}

.positive {
  color: var(--text-up-color);
}
.negative {
  color: var(--text-down-color);
}
.nochange {
  color: var(--text-unchg-color);
}

.mini-chart-empty-container {
  width: 100%;
  height: 100%;
  min-height: 120px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/MiniChartWidget/MiniChartWidget.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".miniChartsWidget {\n  overflow-x: auto;\n  overflow-y: hidden;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  padding: 16px 0;\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n\n.mini-charts-list {\n  display: flex;\n  flex-direction: row;\n  gap: 24px;\n  padding: 0 16px;\n  margin: 0;\n  list-style: none;\n}\n\n.mini-chart-item {\n  flex: 0 0 123px;\n  max-width: 123px;\n  display: flex;\n  flex-direction: column;\n}\n\n.ticker-block {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  margin-bottom: 4px;\n}\n\n.ticker-block .flag-icon svg,\n.ticker-block .flag-icon img {\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  display: block;\n}\n\n.ticker-block .ticker {\n  font-size: 16px;\n  color: var(--text-ticker);\n  font-weight: 700;\n  line-height: 24px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n\n.company-name {\n  width: 100%;\n  font-weight: 400;\n  font-size: 12px;\n  color: var(--text-instrument);\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-bottom: 8px;\n}\n\n.last-price {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1;\n  color: var(--text-primary);\n  margin-bottom: 0px;\n}\n\n.chart-container {\n  width: 100%;\n  height: 50px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.chart-container img,\n.chart-container svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  margin-right: 22px;\n}\n\n.chart-empty-line {\n  width: 100%;\n  height: 20px;\n  border-bottom: 1px dashed var(--border-tertiary);\n}\n\n.pct-chg {\n  width: auto;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 24px;\n  display: flex;\n  align-items: center;\n}\n\n.positive {\n  color: var(--text-up-color);\n}\n.negative {\n  color: var(--text-down-color);\n}\n.nochange {\n  color: var(--text-unchg-color);\n}\n\n.mini-chart-empty-container {\n  width: 100%;\n  height: 100%;\n  min-height: 120px;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
